import { DatePicker } from 'modules/common/components';
import { ComponentProps, FC } from 'react';

import styles from './styles.module.scss';

const ReadOnlyDatePicker: FC<ComponentProps<typeof DatePicker>> = ({
  className,
  ...restProps
}) => {
  const classNames = `${styles.datePicker} ${className}`;

  return <DatePicker {...restProps} className={classNames} disabled />;
};

export default ReadOnlyDatePicker;
